import { render } from "./paymentsettings.vue?vue&type=template&id=0435cca5"
import script from "./paymentsettings.vue?vue&type=script&lang=js"
export * from "./paymentsettings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__